import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5831b425")

_pushScopeId("data-v-5831b425")
const _hoisted_1 = { class: "mylist-select-page" }
const _hoisted_2 = { class: "mylist-select-page-operation" }
const _hoisted_3 = { class: "mylist-select-page-operation-title" }
const _hoisted_4 = { class: "commonTextBodyStrong mylist-select-page-operation-title-text" }
const _hoisted_5 = { class: "mylist-select-page-operation-append" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.recentTitle), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectAppend(...args))),
          class: "mylist-select-page-operation-append-button"
        }, [
          _createVNode("span", { class: _ctx.styleSelectAppendButton }, _toDisplayString(_ctx.appendButtonText), 3)
        ])
      ])
    ]),
    _createVNode("div", {
      class: "mylist-select-page-body",
      onScrollPassive: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onScroll($event)))
    }, [
      _createVNode(_component_CommonRecipeList, {
        key: _ctx.updateDisplayKey,
        recipes: _ctx.recipeList,
        mode: _ctx.selectMode,
        onSelectRecipe: _ctx.selectRecipe,
        onSelectCheck: _ctx.checkRecipe
      }, null, 8, ["recipes", "mode", "onSelectRecipe", "onSelectCheck"])
    ], 32),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryHandler,
      onNegativeClick: _ctx.cancelHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})